/**
 * Paleta do protótipo `sistema/index.html` — constantes `C` e `TONES`, VERBATIM.
 *
 * Todo oklch da página nasce aqui ou está literal no DOM portado (mesmos valores do
 * protótipo). `TONE_DO_STATUS` é o `ST_META[st].tone` do protótipo: o tom visual de
 * cada status canônico da esteira (o LABEL de cada status mora em utils/ordemStatus,
 * fonte única já validada).
 */

import type { StatusEsteira } from './api';

export const C = {
  ink: 'oklch(0.28 0.02 165)',
  sub: 'oklch(0.55 0.015 165)',
  faint: 'oklch(0.62 0.012 165)',
  white: 'oklch(1 0 0)',
  border: 'oklch(0.92 0.006 160)',
  dark: 'oklch(0.22 0.026 168)',
  darkBorder: 'oklch(0.22 0.026 168)',
  onDark: 'oklch(0.96 0.01 160)',
  onDarkSub: 'oklch(0.78 0.02 165)',
  green: 'oklch(0.62 0.14 162)',
  greenFg: 'oklch(0.42 0.11 162)',
  greenBg: 'oklch(0.94 0.04 162)',
  red: 'oklch(0.58 0.18 28)',
  redFg: 'oklch(0.5 0.16 28)',
  redBg: 'oklch(0.95 0.04 28)',
  amber: 'oklch(0.75 0.15 70)',
  amberFg: 'oklch(0.5 0.13 60)',
  amberBg: 'oklch(0.95 0.04 65)',
  blue: 'oklch(0.6 0.13 265)',
  blueFg: 'oklch(0.46 0.11 265)',
  blueBg: 'oklch(0.95 0.02 265)',
  track: 'oklch(0.95 0.008 160)',
} as const;

export type Tone = 'idle' | 'ok' | 'err' | 'warn' | 'run' | 'blue';

export interface ToneCores {
  bg: string;
  fg: string;
  dot: string;
}

export const TONES: Record<Tone, ToneCores> = {
  idle: { bg: 'oklch(0.96 0.006 160)', fg: 'oklch(0.55 0.015 165)', dot: 'oklch(0.78 0.01 165)' },
  ok: { bg: C.greenBg, fg: C.greenFg, dot: C.green },
  err: { bg: C.redBg, fg: C.redFg, dot: C.red },
  warn: { bg: C.amberBg, fg: C.amberFg, dot: C.amber },
  run: { bg: C.blueBg, fg: C.blueFg, dot: C.blue },
  blue: { bg: C.blueBg, fg: C.blueFg, dot: C.blue },
};

/** `ST_META[st].tone` do protótipo — tom visual por status canônico. */
export const TONE_DO_STATUS: Record<StatusEsteira, Tone> = {
  done: 'ok',
  run: 'run',
  err: 'err',
  warn: 'warn',
  // `skip` em cinza, como `wait`: pular nao e' sucesso (verde diria que a
  // obrigacao foi cumprida) nem problema (vermelho/ambar pediriam acao).
  skip: 'idle',
  wait: 'idle',
};

/** Fontes do protótipo (linha 13 do index.html) — usadas em todo style inline portado. */
export const FONTE_TEXTO = "'Instrument Sans', system-ui, sans-serif";
export const FONTE_MONO = "'IBM Plex Mono', monospace";
